import type { Faq } from '~/type/Faq'

export function FaqSerializer(el: any): Faq {
  return {
    name: el.CATEGORY,
    questions: el.QUESTIONS.map((item: any) => ({ name: item.QUESTION, value: item.ANSWER })),
  }
}
